import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Configure axios to send cookies with all requests
axios.defaults.withCredentials = true;

export const ASSETS = {
  hero: "https://static.prod-images.emergentagent.com/jobs/67f4c531-24cf-45d7-96c3-28a58f6fd962/images/4c02f2984325c137d71331558ddc2e2f3e97d430bfdab6d23ba88c0d5a9d2ae2.png",
  magazine: "https://images.unsplash.com/photo-1627561037197-f41503b0a7d4?w=400&h=500&fit=crop&q=70",
  redCarpet: "https://images.unsplash.com/photo-1637348318881-03b4c930a723?w=400&h=500&fit=crop&q=70",
  sports: "https://images.unsplash.com/photo-1648929725819-e43962b46e0c?w=400&h=500&fit=crop&q=70",
  business: "https://images.unsplash.com/photo-1750741268857-7e44510f867d?w=400&h=500&fit=crop&q=70",
  confidence: "https://images.pexels.com/photos/6077664/pexels-photo-6077664.jpeg?auto=compress&cs=tinysrgb&w=400&h=500&fit=crop",
  linkedin: "https://images.unsplash.com/photo-1762522926157-bcc04bf0b10a?w=400&h=500&fit=crop&q=70",
  dating: "https://images.unsplash.com/photo-1763713512963-8838f4483090?w=400&h=500&fit=crop&q=70",
  socialMedia: "https://images.unsplash.com/photo-1586355290683-f53efdd2c749?w=400&h=500&fit=crop&q=70",
  fantasy: "https://images.unsplash.com/photo-1611211303106-99c39bcb75b4?w=400&h=500&fit=crop&q=70",
  renaissance: "https://images.unsplash.com/photo-1775416344132-64351ff26554?w=400&h=500&fit=crop&q=70",
  anime: "https://images.unsplash.com/photo-1712168567859-e24cbc155219?w=400&h=500&fit=crop&q=70",
  passport: "https://images.unsplash.com/photo-1719603785926-fa6c6e10fb90?w=400&h=500&fit=crop&q=70"
};

export const STYLES = [
  { id: "magazine", name: "Magazine Cover", description: "High-fashion editorial", image: ASSETS.magazine },
  { id: "red_carpet", name: "Red Carpet", description: "Hollywood glamour", image: ASSETS.redCarpet },
  { id: "sports", name: "Sports Action", description: "Champion athlete", image: ASSETS.sports },
  { id: "business", name: "Business Executive", description: "CEO power portrait", image: ASSETS.business },
  { id: "confidence", name: "Confidence Boost", description: "Happier, warmer smile", image: ASSETS.confidence },
  { id: "linkedin", name: "LinkedIn Pro", description: "Professional headshot", image: ASSETS.linkedin },
  { id: "dating", name: "Dating Profile", description: "Warm & attractive", image: ASSETS.dating },
  { id: "social_media", name: "Social Media", description: "Vibrant & eye-catching", image: ASSETS.socialMedia },
  { id: "fantasy", name: "Fantasy Epic", description: "Cinematic & dramatic", image: ASSETS.fantasy },
  { id: "renaissance", name: "Renaissance", description: "Classical oil painting", image: ASSETS.renaissance },
  { id: "anime", name: "Anime Style", description: "Manga illustration", image: ASSETS.anime },
  { id: "passport", name: "Passport/ID", description: "Clean official photo", image: ASSETS.passport }
];

export const PACKAGES = [
  { id: "starter", name: "Starter Pack", credits: 7, bonus: 0, price: 10, featured: false },
  { id: "pro", name: "Pro Pack", credits: 30, bonus: 0, price: 29.99, featured: true },
  { id: "ultimate", name: "Ultimate Pack", credits: 150, bonus: 0, price: 79.99, featured: false }
];

export const BACKGROUNDS = [
  { id: "remove", name: "Remove Background", description: "Transparent/white background", icon: "✂️" },
  { id: "studio_white", name: "Studio White", description: "Professional white backdrop", icon: "⬜" },
  { id: "studio_gray", name: "Studio Gray", description: "Classic gray backdrop", icon: "🔲" },
  { id: "office", name: "Modern Office", description: "Sleek corporate setting", icon: "🏢" },
  { id: "city_skyline", name: "City Skyline", description: "Urban golden hour", icon: "🌆" },
  { id: "nature", name: "Nature Scene", description: "Forest & greenery", icon: "🌲" },
  { id: "beach", name: "Tropical Beach", description: "Paradise setting", icon: "🏝️" },
  { id: "luxury", name: "Luxury Interior", description: "Elegant & premium", icon: "✨" }
];

export const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3 } }
};

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
